/**
 * Artisanal Mines Filter Component
 * Handles the "Artisanal Mines" toggle functionality
 * When OFF (default): artisanal mines are excluded from all queries
 * When ON: artisanal mines are included and subject to all other filters
 */

import { useFilterStore } from '../stores/filterStore.js';

export class ArtisanalMinesFilter {
  constructor() {
    this.toggle = null;
    this.countElement = null;
    this.isActive = false;

    // Create bound handler upfront so reattachEventListener always works
    this.handleToggleChangeBound = (e) => {
      this.handleToggleChange(e.target.checked);
    };
  }

  /**
   * Attach event listener after DOM update (called by FilterPanel after render)
   */
  reattachEventListener() {
    this.toggle = document.getElementById('artisanalMinesToggle');
    this.countElement = document.getElementById('artisanalMinesCount');

    if (this.toggle) {
      this.toggle.removeEventListener('change', this.handleToggleChangeBound);
      this.toggle.addEventListener('change', this.handleToggleChangeBound);

      // Sync checkbox state with current filter state
      this.toggle.checked = this.isActive;

      // Load initial state on first attachment
      this.loadInitialState();

      console.log('ArtisanalMinesFilter initialized');
    }
  }

  loadInitialState() {
    // Check URL param first
    const urlParams = new URLSearchParams(window.location.search);
    const artisanal = urlParams.get('artisanal');

    if (artisanal === 'true') {
      this.toggle.checked = true;
      this.handleToggleChange(true);
      return;
    }

    // Check store state
    const state = useFilterStore.getState();
    if (state.includeArtisanal) {
      this.toggle.checked = true;
      this.handleToggleChange(true);
    }
  }

  handleToggleChange(isChecked) {
    this.isActive = isChecked;

    // Update the filter store — this triggers the normal filter pipeline
    const filterStore = useFilterStore.getState();
    filterStore.setFilter('includeArtisanal', isChecked);

    if (isChecked) {
      this.activateFilter();
    } else {
      this.deactivateFilter();
    }

    console.log('ArtisanalMinesFilter:', isChecked ? 'ON' : 'OFF');
  }

  activateFilter() {
    if (this.countElement) {
      this.countElement.style.display = 'inline-block';
    }
  }

  deactivateFilter() {
    if (this.countElement) {
      this.countElement.style.display = 'none';
    }
  }

  /**
   * Programmatically set filter state (used by reset)
   */
  setFilterState(active) {
    if (this.toggle) {
      this.toggle.checked = active;
      this.handleToggleChange(active);
    }
  }

  isFilterActive() {
    return this.isActive;
  }

  destroy() {
    if (this.toggle && this.handleToggleChangeBound) {
      this.toggle.removeEventListener('change', this.handleToggleChangeBound);
    }
  }
}

// Export singleton instance
export const artisanalMinesFilter = new ArtisanalMinesFilter();
